<template>
    <div class="case_reviews_box" v-loading="loading">
            <div class="case_reviews">
                <div class="title_box">
                    <div class="lefts">
                        <div class="title_text1">案例点评</div>
                        <div class="title_text2">CASE REVIEW</div>
                        <div class="title_img">
                            <img src="../../assets/img/index/home/right1.png" alt="">
                        </div>
                    </div>
                    <div class="rights">
                        <div class="btns1" @click="$router.push('/release_index')">申请点评</div>
                        <div class="btns2" @click="$router.push('/comments_list')">专业点评</div>
                    </div>
                </div>
                <div class="case_list_box">
                    <div class="case_list" v-for="(item, index) in list" :key="index" @click="handle_path(item)">
                        <div class="case_title">
                            {{ item.title }}
                        </div>
                        <div class="case_const">
                           {{ item.desc }}
                        </div>
                        <div class="tag_box">
                            <div class="tag_left">
                                <div class="tag1">{{ item.catename }}</div>
                                <div class="tag2">{{ item.case_user.company }}</div>
                            </div>
                            <div class="tag_right">
                                <div class="users" v-for="(items, indexs) in item.lawyer_comments" :key="indexs">
                                    <!-- <img src="../../assets/img/index/home/users.png" alt=""> -->
                                     <img :src="items.lawyer.avatar" alt="">
                                </div>
                                <div class="users" v-if="item.lawyer_comments.length>0">
                                    <img src="../../assets/img/index/home/dian.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="user_info">
                            <div class="info_flex">
                                <div class="imgs">
                                    <!-- <img src="../../assets/img/index/home/users.png" alt=""> -->
                                     <img :src="item.case_user.image" alt="">
                                </div>
                                <div class="name_time">
                                    <div class="names">{{item.case_user.name}}</div>
                                    <div class="times">发布于 {{ item.created_at }}</div>
                                </div>
                            </div>
                            <div class="num_box">
                                <div class="icon_num">
                                    <img src="../../assets/img/index/home/see.png" alt="">
                                    {{ item.views }}
                                </div>
                                <div class="icon_num">
                                    <img src="../../assets/img/index/home/pl.png" alt="">
                                    {{ item.comment_num }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            list:[],
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
     get_list(){
        this.loading=true
        this.$api("caseList", {
            limit:4,
            anliku:1,
        }, "get").then((res) => {
            this.loading = false
            console.log('案例点评',res)
            if (res.code == 1) {
                this.list=res.data.data
            } else {
                alertErr(res.msg)
            }
        });
     },
     handle_path(item){
        this.$router.push({
            path:'/case_detial',
            query:{
                id:item.id
            }
        })
     },




    },

}
</script>
<style scoped lang="less">
 .case_reviews_box {
        width: 100%;
        padding-top: 80px;
        background: #fff;

        .case_reviews {
            width: 1440px;
            // height: 200px;
            // background-color: red;
            padding-bottom: 11px;
            margin: auto;

            .title_box {
              
                display: flex;
                align-items: end;
                // align-content: end;
                justify-content: space-between;
                .lefts{
                    display: flex;
                    align-items: end;
                    .title_text1 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 36px;
                        color: #333333;

                    }

                    .title_text2 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #377CFD;
                        margin-left: 16px;
                    }

                    .title_img {
                        width: 24px;
                        height: 24px;
                        margin-left: 16px;

                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .rights{
                    display: flex;
                    align-items: center;
                    .btns1{
                        width: 180px;
                        height: 40px;
                        border-radius: 20px 20px 20px 20px;
                        border: 1px solid #377CFD;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #377CFD;
                        text-align: center;
                        line-height: 40px;
                    }
                    .btns2{
                        width: 180px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 20px 20px 20px 20px;
                        line-height: 40px;
                        cursor: pointer;
                        text-align: center;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-left: 16px;
                    }
                }
                
            }

            .case_list_box {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                padding-top: 50px;

                .case_list {
                    width: 700px;
                    height: 297px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 40px 1px rgba(43, 89, 255, 0.08);
                    border-radius: 8px 8px 8px 8px;
                    margin-bottom: 40px;
                    padding: 32px 40px;
                    cursor: pointer;
                    .case_title {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                        width: 500px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .case_const {
                        padding-top: 20px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;

                    }

                    .tag_box {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding-top: 18px;
                        padding-bottom: 18px;
                        border-bottom: 2px solid #EDEDED;

                        .tag_left {
                            display: flex;
                            align-items: center;

                            .tag1 {
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #FFAA00;
                                padding: 4px 12px;
                                background: #FDF6EC;
                                border-radius: 3px 3px 3px 3px;
                                border: 1px solid #FFAA00;
                            }

                            .tag2 {
                                padding-left: 10px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                        }

                        .tag_right {
                            display: flex;
                            align-items: center;

                            .users {
                                width: 32px;
                                height: 32px;
                                // background: #C4C4C4;
                                border: 1px solid #FFFFFF;
                                margin-left: -6px;
                                border-radius: 50%;

                                img {
                                    width: 32px;
                                    // height: 32px;
                                }
                            }

                            .users:first-child {
                                margin: 0
                            }
                        }

                    }

                    .user_info {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding-top: 24px;

                        .info_flex {
                            display: flex;
                            align-items: center;

                            .imgs {
                                width: 48px;
                                height: 48px;

                                img {
                                    width: 48px;
                                    height: 48px;
                                }
                            }

                            .name_time {
                                padding-left: 16px;

                                .names {
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;
                                }

                                .times {
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #666666;
                                }
                            }
                        }
                    }

                    .num_box {
                        display: flex;
                        align-items: center;

                        .icon_num {
                            margin-left: 24px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;

                            img {
                                width: 25px;
                                // height: 15px;
                                margin-right: 8px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>